import axios from "axios";
import React from "react";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { url } from "../../../Constant";
import { toast } from "react-toastify";
import { useAuth } from "../../../Context/AuthProvider";
import { checkIndividualPermission } from "../../../Utils/PermissionFunctions";

const NewListManager = () => {
  const { auth } = useAuth();
  const [errorEnable, setErrorEnable] = useState(false);
  const [loader, setLoader] = useState(false);
  const [fileUploadError, setFileUploadError] = useState("");
  const [submittedData, setSubmittedData] = useState({
    firstName: "",
    lastName: "",
    mode: "",
    vpbx_id: auth.vpbx_id,
    userfile: "",
  });

  useEffect(() => {
    if (
      auth.role === "1" ||
      (auth.role === "3" &&
        !checkIndividualPermission("list-manager", "read_and_write"))
    ) {
      window.location.href = "/";
    }
  }, []);
  const handleFile = (e) => {
    var file = e.target.files[0];
    var fileName = e.target.files[0].name;
    let fileNameSplit = fileName.split(".");
    let fileExtensionName = fileNameSplit[1];
    // if (fileExtensionName !== "csv" || fileExtensionName !== "txt") {
    if (fileExtensionName !== "csv") {
      // setFileUploadError("Please upload csv and txt format file format only");
      setFileUploadError("Please upload csv format");
      setSubmittedData({
        ...submittedData,
        userfile: "Invalid File",
      });
    } else {
      setFileUploadError("");
      setSubmittedData({
        ...submittedData,
        userfile: file,
      });
    }
  };
  const createListManager = () => {
    setErrorEnable(true);
    setLoader(true);
    var formData = new FormData();

    formData.append("vpbx_id", submittedData.vpbx_id);
    formData.append(
      "name",
      submittedData.firstName + " " + submittedData.lastName
    );
    formData.append("type", submittedData.mode);
    formData.append("userfile", submittedData.userfile);

    if (
      submittedData.name !== "" &&
      submittedData.firstName !== "" &&
      submittedData.lastName !== "" &&
      fileUploadError === "" &&
      submittedData.userfile !== ""
    ) {
      let api = "";
      if (auth.role === "2") {
        api = "store-list-manager";
      } else {
        api = "user-store-list-manager";
      }

      axios
        .post(url + api, formData, {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        })
        .then(
          (response) => {
            if (response.status === 200) {
              if (response.data.message === "Data added") {
                setLoader(false);
                toast.success("List manager added successfully", {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1500,
                });
                setTimeout(() => {
                  window.location.href = "/list-manager";
                }, 2000);
              } else {
                setLoader(false);
                setFileUploadError("Incorrect file format");
              }
            }
          },
          (error) => {
            console.log(error);
          }
        );
    } else {
      setLoader(false);
    }
  };
  return (
    <div className="dashboardWrp">
      <div className="uk-container uk-container-small">
        <div className="dashboardTop">
          <div uk-grid="" className="uk-grid uk-grid-small">
            <div className="uk-width-2-3">
              <div className="dashboardIntro">
                <Link to="/list-manager">
                  <img src="./assets/images/zong/chevron--left.svg" uk-svg="" />
                  <span>Back to VPBX manager</span>
                </Link>
                <h3>Create a list</h3>
                <p>
                  Enter details for the new user, assign roles, and select teams
                  this user belongs to.
                </p>
              </div>
            </div>
            {/* <div className="uk-width-1-3">
            <div className="dashboardIntro uk-text-right">
              <button>EXPORT DATA</button>
            </div>
          </div> */}
          </div>

          <form action="javascript:void(0);">
            <div className="formCreateMain">
              <div className="uk-grid uk-grid-small">
                <div className="uk-width-1-1@m uk-margin-top">
                  <legend className="uk-legend">ADD LIST</legend>
                </div>
                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Fist name</label>
                  <input
                    className="uk-input"
                    type="text"
                    placeholder="Fist name"
                    aria-label="Input"
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        firstName: e.target.value,
                      });
                    }}
                  />
                  {errorEnable && submittedData.firstName === "" && (
                    <div className="formErrors">first name is required</div>
                  )}
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Last name</label>
                  <input
                    className="uk-input"
                    type="text"
                    placeholder="Last name"
                    aria-label="Input"
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        lastName: e.target.value,
                      });
                    }}
                  />
                  {errorEnable && submittedData.lastName === "" && (
                    <div className="formErrors">last name is required</div>
                  )}
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Mode</label>
                  <select
                    className="uk-select"
                    aria-label="Select"
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        mode: e.target.value,
                      });
                    }}
                  >
                    <option value="" selected>
                      Select a mode...
                    </option>
                    <option value="Black List">Black List</option>
                    <option value="White List">White List</option>
                  </select>
                  {errorEnable && submittedData.mode === "" && (
                    <div className="formErrors">mode is required</div>
                  )}
                </div>

                <div className="uk-width-1-1@m uk-margin-top">
                  <label>
                    <b>Please select any one flow extensions(file input)</b>
                  </label>
                  <span className="fileDisc">
                    Add flow file (only .csv format allowed)
                  </span>
                  <div className="uk-margin-bottom">
                    <div uk-form-custom="target: true">
                      <input
                        type="file"
                        aria-label="Custom controls"
                        accept=".csv"
                        onChange={(e) => handleFile(e)}
                      />
                      <input
                        className="uk-input uk-form-width-medium"
                        type="text"
                        placeholder="Choose files"
                        aria-label="Custom controls"
                        disabled
                      />
                    </div>
                    {/* <button className="uk-button fileUploadBtn uk-button-default">
                      Submit
                    </button> */}
                  </div>
                  {errorEnable && submittedData.userfile === "" && (
                    <div className="formErrors">Please upload file</div>
                  )}
                  {errorEnable && fileUploadError !== "" && (
                    <div className="formErrors">{fileUploadError}</div>
                  )}
                  <a
                    target="_blank"
                    className="DownloadFileBtn"
                    href="http://dashboard.convexinteractive.com/SmartOffice/samples/sample2.csv"
                  >
                    Download sample file
                  </a>
                </div>

                <div className="uk-width-1-1@m uk-float-right">
                  <div className="formActionBtn uk-text-right">
                    {/* <button className="whiteBtn">Cancel</button> */}
                    <button className="pinkBtn" onClick={createListManager}>
                      {loader ? (
                        <div uk-spinner="" className="loader">
                          Adding
                        </div>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewListManager;
